import { color } from '@telus-uds/palette-allium'
import styled from 'styled-components'

export const CardContainer = styled.div`
  > div {
    border: 1px solid ${color.gainsboro};
    border-radius: 4px;
    padding: 0;
    box-shadow: none;
  }
`

export const SubSectionContainer = styled.div`
  hr {
    margin-bottom: 0;
    margin-top: 0;
  }
`

export const HairlineDividerWrapper = styled.div`
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
`

export const BreakdownLineItemWrapper = styled.div`
  div:first-child {
    flex-wrap: nowrap;
  }
`

export const InlineBox = styled.div`
  display: flex;
  flex-flow: column;
  span:first-child {
    min-width: 4rem;
  }

  @media (min-width: 576px) {
    flex-flow: ${({ inline }) => (inline ? 'row' : 'column')};
  }
`

export const WrapInlineBox = styled.div`
  max-width: 72%;
  word-break: break-work;
`

export const HeadlessMultipleLineItemNewDesign = styled.div`
  div:first-child {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    div {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
  div:nth-child(n + 1) {
    padding-bottom: 0.5rem;
    div {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
`

export const MultipleLineItemNewDesign = styled.div`
  div:first-child:not([role='tooltip']) {
    padding-bottom: 0.5rem;
    div:not([role='tooltip']) {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
`

export const PadContentLeft = styled.div`
  padding-left: 5%;
  div:nth-child(n + 1) {
    padding-bottom: 0.5rem;
    div {
      padding-bottom: 0;
      padding-top: 0;
    }
  }
`

export const SingleLineItem = styled.div`
  div:nth-child(n):not([role='tooltip']) {
    div:not([role='tooltip']) {
      padding-top: 0;
    }
  }
`

export const HeadingContainer = styled.div`
  margin-bottom: 1rem;
`

export const SuperScript = styled.sup`
  top: -0.5em;
  position: relative;
  font-size: 0.875rem;
  padding-left: 0.1em;
  vertical-align: baseline;
`

export const CartLinkContainer = styled.div`
  padding-top: 0.25rem;
  text-align: center;
`

export const LineItemWrapper = styled.div`
  div:first-child {
    flex-wrap: nowrap;
  }
`

export const MultipleLineItem = styled.div`
  div:nth-child(n + 2) {
    div {
      padding-top: 0;
    }
  }
`

export const MobilePriceSummary = styled.div`
  @media (min-width: 769px) {
    display: none;
  }
`

export const DesktopPriceSummary = styled.div`
  display: none;

  @media (min-width: 769px) {
    display: block;
    height: 100%;
  }
`

export const InlineTooltip = styled.div`
  display: inline-block;
  margin-left: 6px;
  margin-top: -3px;

  div[role='tooltip'] {
    @media (max-width: 576px) {
      max-width: 40vw;
    }
    @media (min-width: 577px) and (max-width: 768px) {
      max-width: 25vw;
    }
    @media (min-width: 769px) {
      max-width: 15vw;
    }
  }
`
